import React, { useCallback } from "react";
import type { Path } from "react-hook-form";

import type { CheckboxProps } from "@braze/beacon-core";
import { CheckboxField } from "@braze/beacon-forms";

import { BrazeCheckbox } from "@components/BrazeCheckbox";

import type { BrazeCheckboxFieldProps } from "./types";

export const BrazeCheckboxField = <
  TFieldValues extends Record<string, any> = Record<string, any>,
  TName extends Path<TFieldValues> = Path<TFieldValues>,
>({
  operatorLabel,
  operatorDisabledReason,
  ...rest
}: BrazeCheckboxFieldProps<TFieldValues, TName>): React.ReactElement => {
  const Component = useCallback(
    (componentProps: CheckboxProps) => (
      <BrazeCheckbox
        {...componentProps}
        operatorLabel={operatorLabel}
        operatorDisabledReason={operatorDisabledReason}
      />
    ),
    [operatorLabel, operatorDisabledReason]
  );

  return <CheckboxField {...rest} Component={Component} />;
};
